import { render } from "./InformationTemplate.vue?vue&type=template&id=987b8e32&scoped=true&ts=true"
import script from "./InformationTemplate.vue?vue&type=script&lang=ts"
export * from "./InformationTemplate.vue?vue&type=script&lang=ts"

import "./InformationTemplate.vue?vue&type=style&index=0&id=987b8e32&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987b8e32"]])

export default __exports__